import React, { useEffect, useState } from "react";

// MATERIAL UI
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import OrdersList from "../orders/table/OrdersList";
import { ERROR_MESSAGE_SUPPORT } from "../../common/helpersTxt";
import { getOrdersHistory } from "../../api/order";
import Box from "@mui/material/Box";
import InfoModal from "../orders/infoModal";
import { CustomModalRoot } from "../styled/modal";

export default function CustomerOrdersHistoryModal({
  show,
  closeModal,
  dateStart,
  dateEnd,
  customerId,
}) {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const [orders, setOrders] = useState([]);
  const [showButtonMore, setShowButtonMore] = useState(true);

  const [showOrderInfoModal, setShowOrderInfoModal] = useState(false);
  const [infoModalOrderId, setInfoModalOrderId] = useState(false);
  const [infoModalOrderStatusNumber, setInfoModalOrderStatusNumber] =
    useState(false);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!dateStart || !dateEnd || !customerId) {
      setPage(1);
      return;
    }
    loadOrders();
  }, [dateStart, dateEnd, customerId]);

  const showErrorMessage = (message = null) => {
    setErrorMessage(message || ERROR_MESSAGE_SUPPORT);
    setOpenErrorAlert(true);
  };

  const loadOrders = async (newSearch = true) => {
    try {
      setLoading(true);

      const pageNum = newSearch ? 1 : page + 1;
      const params = {
        start_date: dateStart,
        end_date: dateEnd,
        customer_id: customerId,
        page: pageNum,
      };

      const { data } = await getOrdersHistory(params);

      setPage(page + 1);

      let result;
      if (newSearch) {
        result = [...data];
        switchShowButtonMore(data.length);
      } else {
        const new_orders = orders.filter(
          ({ order_id: id1 }) => !data.some(({ order_id: id2 }) => id2 === id1)
        );
        console.log("new_orders", new_orders);
        result = [...data, ...new_orders];
        switchShowButtonMore(new_orders.length);
      }

      setOrders(result);
    } catch (e) {
      showErrorMessage(e.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleShowOrderInfoModal = (item, e) => {
    setShowOrderInfoModal(!showOrderInfoModal);
    setInfoModalOrderId(item.order_id);
    setInfoModalOrderStatusNumber(item.status_number);
  };

  const switchShowButtonMore = (length) => {
    length > 0 ? setShowButtonMore(true) : setShowButtonMore(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="alert-modal"
        aria-describedby="shows-alert-message"
        open={show}
        onClose={closeModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{
          zIndex: 5000,
          border: "none",
          "&:focus-visible": {
            border: "none",
          },
        }}
      >
        <Fade in={show}>
          <CustomModalRoot
            top={40}
            left={50}
            width={50}
            height={75}
            overflow={"auto"}
          >
            <Box sx={{ p: 4 }}>
              <OrdersList
                header={"Pedidos do Cliente"}
                orders={orders}
                showButtonMore={showButtonMore}
                loadOrders={loadOrders}
                actions={{
                  handleOrderModal: handleShowOrderInfoModal,
                }}
                onlyModalAction
              ></OrdersList>
            </Box>
          </CustomModalRoot>
        </Fade>
      </Modal>
      {showOrderInfoModal && (
        <InfoModal
          show={showOrderInfoModal}
          order={infoModalOrderId}
          status={infoModalOrderStatusNumber}
          closeModal={handleShowOrderInfoModal}
        />
      )}
    </>
  );
}
